export default __webpack_public_path__ + "static/media/book-store-2.eb8d33c3.PNG";